module.exports = __webpack_public_path__ + "img/Austria.9edfd5bb.svg";